import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { getComposeEvent } from 'owa-calendar-compose-store-manager';
import type RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import { getCalendarEventFromSurface } from 'owa-calendar-surface-surface-store';
import { fetchFullCalendarEvent } from 'owa-calendar-surface-full-event-locked-store';
import { isSeriesInstance } from 'owa-calendar-event-capabilities';
import {
    setRecurrence as setRecurrenceAction,
    updateDateTimes,
} from 'owa-calendar-compose-form-actions';
import getDatesOnStartTimeZoneChanged from 'owa-datetime-utils/lib/dateSelector/getDatesOnStartTimeZoneChanged';
import { TimeChangeActionType } from 'owa-calendar-helpers-types/lib/TimeChangeActionType';

export const getRecurrence = (event: CalendarEvent) => async () => {
    if (event.Recurrence) {
        return event.Recurrence;
    } else if (isSeriesInstance(event)) {
        const master = fetchFullCalendarEvent(
            event.ItemId,
            null,
            getCalendarEventFromSurface,
            true /** isfetchFullSeriesMasterCalendarEventFromEventInstance */,
            { fetchSource: 'RecurrenceAdapter' }
        );
        if (master.event?.Recurrence) {
            return master.event.Recurrence;
        }
        const masterEvent = await master.fullEventPromise;
        return masterEvent.Recurrence;
    }
    return null;
};

export const setRecurrence = (recurrence: RecurrenceType) => {
    setRecurrenceAction(recurrence);
};

export const getSeriesIdCompose = () => {
    const event = getComposeEvent(null /* formId */);
    if (isSeriesInstance(event)) {
        return Promise.resolve(event.SeriesMasterItemId.Id);
    } else {
        return Promise.resolve(null);
    }
};

export const getSeriesIdRead = (event: CalendarEvent) => () => {
    return Promise.resolve(event.SeriesMasterItemId ? event.SeriesMasterItemId.Id : undefined);
};

export const getTimeZone = () => {
    const event = getComposeEvent(null /* formId */);
    return event.Start.tz;
};

export const getTimeZoneName = () => {
    const event = getComposeEvent(null /* formId */);
    return event.StartTimeZoneId;
};

// As this will convert the start and end times to be based on this time zone,
// this method should be called prior to setting the start or end time
export const setTimeZoneName = (timeZone: string) => {
    const event = getComposeEvent(null /* formId */);

    const newRange = getDatesOnStartTimeZoneChanged(event.Start, event.End, timeZone, timeZone);
    updateDateTimes(newRange, TimeChangeActionType.AddinsTimeZone);
};
